import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { memo } from 'react';
import { ToggleControl } from '.';
const LabeledToggleControl = ({ label, checked, onChange, }) => (_jsxs("div", { className: "px-2 py-1.5 bg-white rounded border-2 border-black/25 flex items-center justify-between gap-x-2", children: [_jsx(ToggleControl, { label: label, checked: checked, onChange: onChange }), _jsx("span", { className: "text-sm text-gray-500", children: label })] }));
LabeledToggleControl.propTypes = {
    label: PropTypes.string,
    checked: PropTypes.bool,
    toggleName: PropTypes.string,
    onChange: PropTypes.func,
};
export default memo(LabeledToggleControl);
